import { useEffect, useRef } from "react";
import { useParams } from "react-router";

import { useSelector } from "@jti/store/reduxHooks";
import { useTranslations } from "@jti/ui";

import { CheckoutProgressGtmObserver } from "@checkout/components/CheckoutProgressGtmObserver";
import { HeaderWithBreadcrumbs } from "@checkout/components/HeaderWithBreadcrumbs";
import { OrderErrorView } from "@checkout/components/OrderErrorView";
import { CheckOutSteps } from "@checkout/constants/checkout-constants";
import { useFreeTrial } from "@checkout/hooks/useFreeTrial";
import { useOrder } from "@checkout/hooks/useOrder";
import { PageBaseLayout } from "@checkout/layouts/PageBaseLayout";

import { PaymentPageAside } from "./components/PaymentPageAside";
import { PaymentPageContent } from "./components/PaymentPageContent";

export const PaymentPage = () => {
  const asideSubmitButtonWrapperRef = useRef<HTMLDivElement>(null);
  const { orderId } = useParams<{ orderId: string }>();

  const { __ } = useTranslations();
  const { isFreeTrial } = useFreeTrial();

  const { visible: isErrorVisible, exception } = useSelector((state) => state.checkout.error);
  const { fetchOrder, orderFetchStatus } = useOrder();

  useEffect(() => {
    if (orderFetchStatus === "idle") {
      fetchOrder(orderId);
    }
  }, [orderId, fetchOrder, orderFetchStatus]);

  return (
    <>
      <CheckoutProgressGtmObserver step={CheckOutSteps.Payment} />
      <PageBaseLayout
        header={
          <HeaderWithBreadcrumbs
            title={__(isFreeTrial ? "cart.title.freeTrial" : "cart.title.checkout")}
            step={CheckOutSteps.Payment}
          />
        }
        content={<PaymentPageContent asideSubmitButtonWrapperRef={asideSubmitButtonWrapperRef} />}
        aside={<PaymentPageAside submitButtonWrapperRef={asideSubmitButtonWrapperRef} />}
        exception={(exception || isErrorVisible) && <OrderErrorView exception={exception} />}
      />
    </>
  );
};
